export class AuthMethodUnsatisfiableError extends Error {}
